/* eslint-disable array-callback-return */
/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState, useImperativeHandle, Fragment } from 'react';
import { useSelector } from "react-redux";
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import { capitalizeFirstLetter, getColumnWidth, idNamingConversion, checkComponentPermission, currencyFormat, checkProductSearch, storageSetItem } from '../../../../../helpers/utilities';
import { Space } from "antd";
import { Button, Box } from "@mui/material";
import { HeaderView, LinesList } from "./Blocks";
import crudActions from "../../../../CRUD/redux/actions";
import unitActions from "../../../Setup/redux/actions";
import { CustomModal } from "../../../../Shared/components/DeleteModal";
import { Link, } from "react-router-dom";
import usePrevious from "../../../../Shared/components/Previous";
import { useEventListener } from "../../../../../helpers/useEventListener";
import { AESEncrypt } from "../../../../../helpers/Crypto";
import productActions from "../../../Product/redux/actions";
import productSetupActions from "../../../Setup/redux/actions";
import { toast } from 'react-toastify';
import { getRequest } from '../../../../../helpers/axiosClient';



export const CustomForm = React.forwardRef((props, ref) => {
    const { businessDetails, parameterDetails } = useSelector(state => state.homeReducer);
    const { view, stockId, showDetails, type, clsx, history, dispatch, classes, roleManagement } = props;
    const { createDetails, createError, createLoader, editDetails, editError, editLoader, createData } = useSelector(state => state.crudReducer);
    const { myProductdetails } = useSelector(state => state.productProductReducer);
    const { unitMesurementdetails, locationDetails } = useSelector(state => state.productSetupReducer);
    const { productGroupDetails } = useSelector(state => state.productSetupReducer);

    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);

    const childRef = useRef('');
    const formRef = useRef('');
    const [search, setSearch] = useState('');
    const [searchType, setSearchType] = useState(checkProductSearch());
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);


    const [form, setForm] = useState({
        createTs: new Date()
    });
    const [batch, setBatch] = useState([]);
    const [confirm, setConfirm] = useState(false);
    const [status, setStatus] = useState('CREATED');
    const [lines, setLines] = useState([]);
    const [linesSearch, setLinesSearch] = useState([]);


    useEffect(() => {
        loadTasks();
        return () => {
            dispatch({ type: productActions.CLEAR_PRICE_START });
        };
    }, []);

    useEffect(() => {
        setLinesSearch(search === '' ? lines : filterLines(lines, search));
    }, [lines]);

    const loadTasks = () => {
        locationApi();
        dispatch({
            type: unitActions.UNITMESUREMENT_DETAILS_START, url: 'unit', filter: {
                order: 'id  desc'
            }
        });
    };

    const handleSubmit = (e, status = 'CREATED') => {
        e.preventDefault();
        handleCommonSubmit(status);
    }

    const likeMatch = (field, value) => {
        return String(field ?? "").toLowerCase().includes(value.toLowerCase());
    }

    const exactMatch = (field, value) => {
        if (field === null || field === undefined || field === '') {
            return false;
        }
        if (String(field).trim().toLowerCase() === value.toLowerCase()) {
            return true;
        }
        const a = Number(field);
        const b = Number(value);
        return !isNaN(a) && !isNaN(b) && a === b;
    }

    const filterLines = (list, value) => {
        const v = value.trim().toLowerCase();
        if (v === '') {
            return list;
        }
        return list?.filter((el) => {
            if (checkProductSearch() === 'name') {
                return likeMatch(el?.product?.productName, v);
            }
            if (checkProductSearch() === 'code') {
                return exactMatch(el?.product?.code, v);
            }
            if (checkProductSearch() === 'both') {
                return likeMatch(el?.product?.productName, v) || exactMatch(el?.product?.code, v);
            }
            if (checkProductSearch() === 'mrp') {
                return exactMatch(el?.product?.mrp, v);
            }
            return (
                likeMatch(el?.product?.productName, v) ||
                likeMatch(el?.product?.productId, v) ||
                likeMatch(el?.product?.barcode, v) ||
                exactMatch(el?.product?.code, v) ||
                likeMatch(el?.unit?.name, v) ||
                likeMatch(el?.location?.name, v) ||
                likeMatch(el?.amount, v) ||
                likeMatch(el?.pricePerUnit, v) ||
                likeMatch(el?.quantity, v)
            );
        });
    }

    const changeSearchType = (value) => {
        storageSetItem('productSearch', value);
        setSearchType(value);
        setLinesSearch(filterLines(lines, search));
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 0 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                setLinesSearch(lines);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    setLinesSearch(filterLines(lines, search));
                }, 500);
            }
        }
    }, [search]);

    const handleCommonSubmit = (status, callDispatch = true) => {
        childRef?.current?.handleAdjustHeight();
        let aL = [];

        let lineError = { isValid: true, errors: '' };
        lines?.forEach((element) => {
            if (element.quantity === '' || element.quantity == null) {
                lineError = { isValid: false, errors: `Line Number ${element.lineNumber} quantity field can't be blank` };
            }
            if (element.locationId === '' || element.locationId == null) {
                lineError = { isValid: false, errors: `Line Number ${element.lineNumber} location field can't be blank` };
            }
            if (element.unitId === '' || element.unitId == null) {
                lineError = { isValid: false, errors: `Line Number ${element.lineNumber} unit field can't be blank` };
            }
            if (element?.batchDetails?.length > 0 && element?.batchOverride) {
                let batchQuantity = element?.batchDetails?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.stockCount || 0)), 0);
                if (batchQuantity !== parseFloat(element?.quantity)) {
                    lineError = { isValid: false, errors: `Line Number ${element.lineNumber} Total Batch quantity should equal Line Quantity` }
                }
            }
        });
        if (lineError?.isValid) {
            lines && lines?.length > 0 && lines?.map((element, i) => {
                return aL.push({ ...element })
            });

            if (callDispatch) {
                form.countStatus = status || null;
                form.unitId = form?.unitId || undefined;
                let subForm = { ...form };
                if (Array.isArray(aL) && aL.length > 0) {
                    aL.forEach(element => {
                        delete element.location;
                        delete element.product; delete element.bulk;
                        delete element.unit; delete element.batch;
                        if (Array.isArray(element.batchDetails) && element.batchDetails.length > 0) {
                            element.batchDetails.forEach(e => {
                                delete e.currentStock;
                            });
                        } else {
                            delete element.batchDetails; // remove if empty or not an array
                        }
                    });
                }

                subForm.stockCountItems = aL;
                delete subForm.createTs; delete subForm.unit; delete subForm.updateTs; delete subForm.updatedBy; delete subForm.createdBy; delete subForm.business;
                dispatch({
                    type: subForm?.id ? crudActions.EDIT_DETAILS_START : crudActions.CREATE_DETAILS_START,
                    url: 'stockCount',
                    title: 'Stock Count',
                    id: subForm?.id,
                    details: subForm
                })
            } else {
                return form
            }
        } else {
            toast.dismiss();
            toast.error(lineError?.errors);
        }
    }

    const customObject = (details, id) => {
        let a = details && details?.filter((el) => { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }


    const deleteLine = async (index) => {
        // Find the line at the given index
        const line = lines[index];
        if (!line) return;

        try {
            // If the line exists in DB (has an id), call backend API
            if (line.id) {
                await dispatch({
                    type: crudActions.DELETE_DETAILS_START,
                    url: `stockCountLines/delete`,  // use RESTful route
                    id: line?.id,                // ensure DELETE request
                    title: 'Stock Count Line',
                });
            }

            // Remove from local state
            const updatedLines = lines.filter((_, i) => i !== index);
            setLines(updatedLines);

        } catch (error) {
            console.error('Error deleting line:', error);
            toast.error('Failed to delete line. Please try again.');
        }
    };

    const handleBulkDelete = (selected) => {
        setLines((prevLines) => prevLines.filter(
            (line) => !selected.includes(line.lineNumber)
        ));
        let ids = lines.filter(line => selected.includes(line.lineNumber) && line?.id).map(line => line.id);
        if (ids?.length > 0) {
            dispatch({
                type: crudActions.DELETE_DETAILS_START,
                url: 'stockCountLines/deleteByIds',
                title: 'Stock Count Lines',
                details: ids
            });
        }
        formRef.current.handleSelected([]);
    };

    const lineSubmit = (data, lineId = '') => {
        if (lineId !== '') {
            let index = lines.findIndex((d, i) => lineId === i);
            if (index >= 0) {
                lines.splice(index, 1, data);
            }
        } else {
            setLines((prevState) => {
                return [...prevState, data];
            });
        }
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            setConfirm(false);
            setStatus(form.countStatus);
            history.push(`/product/inventory/stock-count/${AESEncrypt(createData.id)}/view`, `create`);
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message;
            //setCommonError(error);
            toast.dismiss();
            toast.error(error);
        }
    }, [createDetails, createError]);

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            setConfirm(false);
            setStatus(form.countStatus);
            history.push(`/product/inventory/stock-count/${AESEncrypt(stockId)}/view`, `${type}`);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            toast.dismiss();
            let text = editError.error.message;
            toast.error(text);
        }
        childRef?.current?.handleAdjustHeight();
    }, [editDetails, editError]);


    const createProduct = (filterForm) => {
        let filter = [];

        if (filterForm.productId) {
            filter.push({ productId: filterForm.productId });
        }

        if (filterForm.groupId) {
            filter.push({ productGroupId: filterForm.groupId });
        }

        if (filterForm.type) {
            filter.push({ type: filterForm.type });
        }

        if (filterForm.locationId) {
            filter.push({ locationId: filterForm.locationId });
        }

        getRequest(`${process.env.REACT_APP_API_URL}/stock-on-hands/customFilter?customFilter=${encodeURIComponent(JSON.stringify(filter))}`)
            .then(async uResponse => {
                let uData = uResponse.data;
                if (uData && uData.length > 0) {
                    let lineNumber = (lines?.length ?? 0) + 1;
                    const acc = {};

                    for (const el of uData) {
                        const productId = el.product?.id || null;
                        if (!productId) return acc;
                        let units = await formRef.current.handleUnits(el.product);
                        let unit = el.product.salesUnit || null;
                        let unitId = el.product.salesUnitId || null;
                        if (units.find(el => el.id === form?.unitId)) {
                            unit = form?.unit;
                            unitId = form?.unitId;
                        }
                        // Initialize group if not exist
                        if (!acc[productId]) {
                            acc[productId] = {
                                product: el.product || null,
                                bulk: true,
                                productId,
                                currentStock: 0,
                                countedQuantity: 0,
                                quantity: 0,
                                pricePerUnit: parseFloat(el?.costPrice) || 0,
                                amount: 0,
                                unitId: unitId || null,
                                unit: unit || null,
                                locationId: el.locationId || null,
                                location: el.location || null,
                                batchOverride: el.product?.batchActivation || false,
                                batchDetails: [],
                            };
                        }

                        if (el.batch) {
                            const { id, ...rest } = el.batch;
                            const batch = {
                                ...rest,
                                batchId: id,
                                currentStock: rest.availableStock,
                                countedQuantity: 0,
                            };

                            // Compute stock count difference
                            batch.stockCount = batch.countedQuantity - batch.currentStock;
                            acc[productId].batchDetails.push(batch);
                        }
                        let locationId = ''; let location = '';
                        if (locationDetails && locationDetails?.length > 0) {
                            let a = locationDetails?.filter(el => el.default);
                            if (a?.length) {
                                locationId = a[0]?.id;
                                location = a[0];
                            } else {
                                locationId = locationDetails[0]?.id;
                                location = locationDetails[0];
                            }
                        }

                        //Aggregate stock and amount
                        // if (locationId === el.locationId) {
                            const physicalQty = parseFloat(el.physicalQtyUnit) || 0;
                            const costPrice = parseFloat(el.costPrice) || 0;
                            acc[productId].locationId = locationId;
                            acc[productId].location = location;
                            acc[productId].currentStock = physicalQty;
                            acc[productId].quantity = physicalQty; // equivalent to 0 - physicalQty
                            acc[productId].amount = acc[productId].quantity * costPrice;
                        // }
                    }
                    const groupedData = Object.values(acc);

                    // const groupedData = Object.values(
                    //     uData.reduce(async (acc, el) => {
                    //         const productId = el.product?.id || null;
                    //         if (!productId) return acc;
                    //         let units = await formRef.current.handleUnits(el.product);
                    //         let unit = el.salesUnit || null;
                    //         let unitId = el.salesUnitId || null;

                    //         if (units.find(el => el.id === form?.unitId)) {
                    //             unit = form?.unit;
                    //             unitId = form?.unitId;
                    //         }
                    //         // Initialize group if not exist
                    //         if (!acc[productId]) {
                    //             const physicalQty = parseFloat(el.physicalQtyUnit) || 0;
                    //             const costPrice = parseFloat(el.costPrice) || 0;
                    //             acc[productId] = {
                    //                 product: el.product || null,
                    //                 bulk: true,
                    //                 productId,
                    //                 currentStock: 0,
                    //                 countedQuantity: 0,
                    //                 quantity: 0,
                    //                 pricePerUnit: parseFloat(el?.costPrice) || 0,
                    //                 amount: 0,
                    //                 unitId: unitId || null,
                    //                 unit: unit || null,
                    //                 locationId: el.locationId || null,
                    //                 location: el.location || null,
                    //                 batchOverride: el.product?.batchActivation || false,
                    //                 batchDetails: [],
                    //             };
                    //         }

                    //         if (el.batch) {
                    //             const { id, ...rest } = el.batch;
                    //             const batch = {
                    //                 ...rest,
                    //                 batchId: id,
                    //                 currentStock: rest.availableStock,
                    //                 countedQuantity: 0,
                    //             };

                    //             // Compute stock count difference
                    //             batch.stockCount = batch.countedQuantity - batch.currentStock;
                    //             acc[productId].batchDetails.push(batch);
                    //         }
                    //         let locationId = ''; let location = '';
                    //         if (locationDetails && locationDetails?.length > 0) {
                    //             let a = locationDetails?.filter(el => el.default);
                    //             if (a?.length) {
                    //                 locationId = a[0]?.id;
                    //                 location = a[0];
                    //             } else {
                    //                 locationId = locationDetails[0]?.id;
                    //                 location = locationDetails[0];
                    //             }
                    //         }

                    //         //Aggregate stock and amount
                    //         if (locationId === el.locationId) {
                    //             const physicalQty = parseFloat(el.physicalQtyUnit) || 0;
                    //             const costPrice = parseFloat(el.costPrice) || 0;
                    //             acc[productId].locationId = locationId;
                    //             acc[productId].location = location;
                    //             acc[productId].currentStock = physicalQty;
                    //             acc[productId].quantity = physicalQty; // equivalent to 0 - physicalQty
                    //             acc[productId].amount = acc[productId].quantity * costPrice;
                    //         }


                    //         return acc;
                    //     }, {})
                    // );
                    console.log(groupedData);
                    // Assign line numbers and push to state
                    const updatedData = groupedData.map((item) => ({
                        ...item,
                        lineNumber: lineNumber++,
                    }));

                    setLines((prev) => [...prev, ...updatedData]);
                    formRef.current.handleFilterForm();
                }
            })
            .catch(error => {
                console.error("Error fetching data", error);
            });
    }

    useImperativeHandle(ref, () => ({
        onEdit(data) {
            setForm({ ...data });
            setStatus(data?.countStatus);
            if (data?.stockCountItems) {
                setLines(data?.stockCountItems);
                setTimeout(() => {
                    const products = data?.stockCountItems?.map(el => el?.product).filter(Boolean); // remove null/undefined
                    // Call handleBulkUnits once for all products
                    formRef.current.handleBulkUnits(products);
                })
            }
        }
    }))

    const productApi = (search = '', id = '') => {
        let filter = { ["and"]: [{ status: 'ACTIVE' }] };
        let or = { ["or"]: [] };

        if (search !== undefined && search !== null && search !== '') {
            or['or'].push({ productName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ description: { like: '%' + search.trim() + '%' } });
            or['or'].push({ productId: { like: '%' + search.trim() + '%' } });
            or['or'].push({ barcode: { like: '%' + search.trim() + '%' } });
            or['or'].push({ code: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            or['or'].push({ id: id });
        }

        filter['and'].push(or);
        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const locationApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };

        if (search) {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
        }

        if (id) {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: productSetupActions.LOCATION_DETAILS_START, url: 'locations',
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const productGroupApi = () => {
        dispatch({
            type: productSetupActions.PRODUCT_GROUP_DETAILS_START, url: 'product-groups',
            filter: {
                order: 'id desc'
            },
        });
    }

    const calculateLineTotal = (el) => {
        let qty = parseFloat(parseFloat(el?.countedQuantity) - parseFloat(el?.currentStock));
        let amt = parseFloat(el?.countedQuantity) * el.pricePerUnit;
        return {
            ...el,
            quantity: qty,
            amount: amt
        };
    };

    const changeHandlerLine = (data, e, name = '', relation = '') => {
        const newTodos = lines.map((el) => {
            if (el.lineNumber === data.lineNumber) {
                if (relation !== '') {
                    const d = { ...el, [name]: e.id, [relation]: e };
                    return calculateLineTotal(d);
                } else {
                    const d = { ...el, [name]: e };
                    return calculateLineTotal(d);
                }
            }
            return el; // ✅ keep other rows unchanged
        });

        setLines(newTodos);
    };

    const handleConfirmSubmit = (e) => {
        e.preventDefault();
        let data = handleCommonSubmit('CONFIRMED', false);
        if (data) {
            setConfirm(true);
        }
    }

    const addBatch = (form) => {
        setBatch((prevState) => {
            return [...prevState,
            { batchNumber: '', currentStock: 0, countedQuantity: 0, stockCount: 0, manufacturingDate: parameterDetails?.batchMfgDate ? new Date() : null, expiryDate: parameterDetails?.batchExpiryDate ? new Date() : null, useByDate: parameterDetails?.batchBestBeforeDate ? new Date() : null }];
        });
    }

    const changeHandler = (e, name, relation) => {
        setForm((prev) => ({
            ...prev,
            [name]: e.id,
            [relation]: e
        }));
    }

    // const changeHandlerBatch = (e, name, i) => {
    //     // Create a shallow copy of the array
    //     const updatedArr = [...batch];

    //     // Update the specific element immutably        
    //     updatedArr[i] = {
    //         ...updatedArr[i],
    //         [name]: e,
    //     };

    //     const newArr = updatedArr.map(el => ({
    //         ...el,
    //         stockCount: (el.countedQuantity || 0) - (el.currentStock || 0)
    //     }));

    //     setBatch(newArr);
    // };

    const changeHandlerBatch = (e, name, i) => {
        setBatch(prev => {
            const updatedArr = [...prev];

            updatedArr[i] = {
                ...updatedArr[i],
                [name]: e,
                stockCount:
                    name === "countedQuantity" || name === "currentStock"
                        ? (name === "countedQuantity" ? e : updatedArr[i].countedQuantity || 0) -
                        (name === "currentStock" ? e : updatedArr[i].currentStock || 0)
                        : updatedArr[i].stockCount
            };

            return updatedArr;
        });
    };

    const onDeletBatch = (data) => {
        let selectedSIngleIndex = batch?.findIndex(el => el.batchNumber === data.batchNumber);
        if (selectedSIngleIndex >= 0) {
            setBatch(prevState => {
                return prevState.filter((value, i) => i !== selectedSIngleIndex)
            });
            // setErrorBatchQuantity(false);
        }
        return false;
    }


    return (
        <Fragment>
            <CustomAccordion
                title={`${capitalizeFirstLetter(type)} Stock Count`}
                top={"0"}
                topVisible={"50px"}
                zIndex={9}
                showDetails={showDetails}
                index={0}
                ref={childRef}
                component={
                    <Box
                        className={clsx(classes.removeUnderline, classes.positionRelative)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => handleSubmit(e)}>
                        {
                            showDetails ? <div className={classes.textAlignCenter}>
                                <div className={classes.loadMoreCircle}></div>
                            </div> : <>
                                <div className={clsx(classes.tabWrapSubmit)}>
                                    <Space size={[20, 20]} direction="horizontal" align="center">
                                        {
                                            roleManagement !== '' && checkComponentPermission('Stock Count', 'Page', 'Confirm') && status === 'CREATED' &&
                                            <Button
                                                tabIndex={-1}
                                                key="confirm"
                                                color="primary"
                                                variant="contained"
                                                id={idNamingConversion('Confirm', 'stockCount', 'Button')}
                                                onClick={(e) => handleConfirmSubmit(e)}
                                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader || createLoader }, { [classes.disabled]: lines.length === 0 })}
                                            >Confirm</Button>
                                        }
                                        {
                                            status === 'CREATED' && <>
                                                {
                                                    (type === 'edit' || type === 'create') ? <Button
                                                        tabIndex={-1}
                                                        key="Save"
                                                        type="submit"
                                                        color="primary"
                                                        variant="contained"
                                                        id={idNamingConversion('Save', 'stockCount', 'Button')}
                                                        className={clsx(classes.modalBtn, { [classes.loading]: editLoader || createLoader })}
                                                    >{type === 'create' ? 'Save' : 'Update'}</Button> : <Link
                                                        to={`/product/inventory/stock-count/${AESEncrypt(stockId)}/edit`}
                                                        id={idNamingConversion('Edit', 'stockCount', 'Link')}
                                                        className={clsx(classes.AddMoreBtn, classes.bold, classes.marginRight0, { [classes.loadingA]: editLoader || createLoader })}>Edit</Link>
                                                }
                                            </>
                                        }
                                    </Space>
                                </div>
                                <div className={classes.tabDesign}>
                                    <HeaderView {...props}
                                        form={form}
                                        view={view}
                                        status={status}
                                        capitalizeFirstLetter={(v) => capitalizeFirstLetter(v)}
                                        idNamingConversion={(name, place = 'menu', fieldType = '') => idNamingConversion(name, place, fieldType)}
                                        customObject={(details, id) => customObject(details, id)}
                                        changeHandler={(e, name, relation) => changeHandler(e, name, relation)}
                                        unitMesurementdetails={unitMesurementdetails}
                                    />
                                </div>
                            </>
                        }
                    </Box>
                }
            />
            <CustomAccordion
                title={'Stock Count Lines'}
                top={"49"}
                topVisible={"150px"}
                zIndex={7}
                showDetails={showDetails}
                index={1}
                ref={childRef}
                component={
                    <>
                        {
                            showDetails ? <div className={classes.textAlignCenter
                            } >
                                <div className={classes.loadMoreCircle}></div>
                            </div > : <LinesList
                                classes={classes}
                                form={form}
                                ref={formRef}
                                type={type}
                                useEventListener={useEventListener}
                                idNamingConversion={(name, place = 'menu', fieldType = '') => idNamingConversion(name, place, fieldType)}
                                clsx={clsx}
                                lines={linesSearch}
                                dispatch={dispatch}
                                customObject={(details, id) => customObject(details, id)}
                                productApi={(s = '', id = '') => productApi(s, id)}
                                productGroupApi={() => productGroupApi()}
                                productActions={productActions}
                                productGroupDetails={productGroupDetails}
                                myProductdetails={myProductdetails}
                                businessDetails={businessDetails}
                                unitMesurementdetails={unitMesurementdetails}
                                getColumnWidth={(head, v) => getColumnWidth(head, v)}
                                deleteLine={(id) => deleteLine(id)}
                                lineSubmit={(data, id) => lineSubmit(data, id)}
                                headerView={view}
                                view={view}
                                currencyFormat={(amount) => currencyFormat(amount)}
                                parameterDetails={parameterDetails}
                                roleManagement={roleManagement}
                                locationDetails={locationDetails}
                                changeHandlerLine={(data, e, name = '', relation = '') => changeHandlerLine(data, e, name, relation)}
                                checkComponentPermission={(v, page, d) => checkComponentPermission(v, page, d)}
                                search={search}
                                setSearch={(s) => setSearch(s)}
                                searchType={searchType}
                                changeSearchType={(v) => changeSearchType(v)}
                                createProduct={(data) => createProduct(data)}
                                handleBulkDelete={(selected) => handleBulkDelete(selected)}
                                batch={batch}
                                addBatch={(f) => addBatch(f)}
                                setBatch={(d) => setBatch(d)}
                                changeHandlerBatch={(e, name, i) => changeHandlerBatch(e, name, i)}
                                onDeletBatch={(d) => onDeletBatch(d)}
                            />
                        }
                    </>
                }
            />

            <CustomModal
                visible={confirm}
                yesButton={'Yes'}
                noButton={'No'}
                title={'Stock Count Confirmation'}
                loading={createLoader || editLoader}
                onOpen={() => handleCommonSubmit('CONFIRMED')}
                onClose={() => setConfirm(false)}
                text={< p > Are you sure do you want to Confirm the Stock Count ?</p >}
            />
        </Fragment>
    )
})